import type {
  ContainerSummary,
  GridSummary,
  PlateSummaryExtras,
  StorableSummaryExtras,
} from 'constants/SampleConstants';
import type {ListingPagination} from 'lib/Listings';

export const CONTAINABLE_LISTING_EVENT_PAYLOADS = {
  CONTAINABLE_LIST_CONTAINERS_STARTED: {} as {
    containableId: string;
    listingId: string;
  },
  CONTAINABLE_LIST_CONTAINERS_COMPLETED: {} as {
    listingId: string;
    containers: Array<ContainerSummary>;
    pagination: ListingPagination;
    storableSummaryExtras?: StorableSummaryExtras;
  },
  CONTAINABLE_LIST_CONTAINERS_FAILED: {} as {
    listingId: string;
  },
  CONTAINABLE_LIST_PLATES_STARTED: {} as {
    containableId: string;
    listingId: string;
  },
  CONTAINABLE_LIST_PLATES_COMPLETED: {} as {
    listingId: string;
    plates: Array<GridSummary>;
    pagination: ListingPagination;
    plateSummaryExtras?: PlateSummaryExtras;
    storableSummaryExtras?: StorableSummaryExtras;
  },
  CONTAINABLE_LIST_PLATES_FAILED: {} as {
    listingId: string;
  },
  CONTAINABLE_CLEAR_CONTAINER_LISTING: {} as {
    listingId: string;
  },
  CONTAINABLE_CLEAR_PLATE_LISTING: {} as {
    listingId: string;
  },
} as const;

export type ContainableListingEventPayload = typeof CONTAINABLE_LISTING_EVENT_PAYLOADS;
